import { PipeTransform, Pipe } from '@angular/core';

@Pipe({
    name: 'dateToString',
    pure: false
})
export class DateToString implements PipeTransform {
    transform(date: any, args?: any): any {
        if(!date)
            return '';

        let d = new Date(date+(date.indexOf(':') > -1? '' : ' 00:00:01'));
        return d.toLocaleDateString('pt-BR', args);
   
    }
}